import RatingCategories from './RatingCategories'

export default RatingCategories
